import { ComponentsStore } from './../core-services/components/components.store';
import { Component, HostListener, OnInit } from '@angular/core';
import { takeUntil, debounceTime, filter, map } from "rxjs/operators";
import { Observable } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GamesNumberConfig } from './games-results.models';
import { BaseComponent } from "../base.component";
import { Game } from '../core-services/games/games.model';
import { GamesStore } from '../core-services/games/games.store';

import { GamesDetailsComponent } from '../game-details/games-details.component';
import { UserStore } from '../core-services/user/user.store';
import { UserDetails } from '../core-services/user/user.model';
import { GameTypesEnum } from '../slider/slider.models';
import { PrefixLangs } from '../core-services/core.models';
import { VisitorStore } from '../core-services/visitor/visitor.store';

export const GAMES_RESULTS_SELECTOR = 'whg-search-results';

@Component({
  selector: `${GAMES_RESULTS_SELECTOR}-home`,
  templateUrl: './games-results.component.html',
  styleUrls: ['./games-results.component.scss'],
})
export class GamesResultsComponent extends BaseComponent implements OnInit {

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalService.dismissAll();
  }

  gamesNumberConfig: GamesNumberConfig;
  readonly inputTimeDelay = 500;

  sliderTypes = GameTypesEnum;
  gamesResults: Game[];
  searchInputData: string;
  showBar: boolean;
  isLoggedIn: boolean;

  loader: boolean = true;

  private gameResults$: Observable<Game[]> = this.gameStore.filteredGames$;
  private searchedGame$: Observable<string> = this.componentStore.searchedGames$;
  private userDetails$: Observable<UserDetails> = this.userStore.userDetails$;

  get resultsLenght(){
    return this.gamesResults.length;
  }

  constructor(
    private gameStore: GamesStore,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private userStore: UserStore,
    private visitorStore: VisitorStore,
    private componentStore: ComponentsStore
  ) {
    super(PrefixLangs.GamesResults);
  }

  ngOnInit() {

     // Used for skeleton loader if 0 results are found, we don't show the loader
     setTimeout(() => {
      this.loader = false;
     }, 3000);

     this.visitorStore.jurisdication$.pipe(takeUntil(this.destroy$)).subscribe(jurisdiction => {
      /*
      * Set language if any from the cookie, get configuration and listen for language switching
      */
      this.jurisdiction = jurisdiction;
      super.ngOnInit();
      this.config$.pipe(takeUntil(this.destroy$)).subscribe((gamesNumberConfig: GamesNumberConfig) => {
          this.gamesNumberConfig = gamesNumberConfig;
      });
    });

    this.gamesResults = [];
    this.searchInputData = '';

    this.searchedGame$.pipe(takeUntil(this.destroy$))
      .subscribe((search) => {
        this.searchInputData = search;
        this.gamesResults = [];
        this.showBar = false;
      });

      this.gameResults$.pipe(takeUntil(this.destroy$), filter(x => !!x)) // filter here prevents us form getting undefined values
      .pipe(debounceTime(this.inputTimeDelay))
      .subscribe((games) => {
        this.gamesResults = games;
        this.showBar = true;
      });

      this.userStore.addUserDetails(this.coreService.getUserDetails());
      this.userDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe(userDetails => {
        if(userDetails.userid) {
          this.isLoggedIn = true;
        }
      });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  openGameDetails(launchCode: string): void {
    const gameByLaunchCode$: Observable<Game[]> = this.gameStore.getGameDetails(launchCode);
    gameByLaunchCode$.pipe(takeUntil(this.destroy$), filter(x => !!x && x.length > 0))
      .subscribe(() => {
        this.coreService.addModalStateHistory();
        this.modalService.open(GamesDetailsComponent, {
          ariaLabelledBy: "game-details-title",
          windowClass: "game-details-modal",
        }).result.then(() => {
        }).catch(() => {
        });
      }).unsubscribe();
  }

  getGameName(launchCode: string): Observable<string> {
    const gameByLaunchCode$: Observable<Game> = this.gameStore.getGameByLaunchCode(launchCode);
    return gameByLaunchCode$.pipe(
      filter(x => !!x),
      map(game => game.name));
  }

}
